import React from "react";
import { connect } from "react-redux";

import TopFooter from "./TopFooter/TopFooter";
import BottomFooter from "./BottomFooter/BottomFooter";

import "./Footer.scss";

const Footer = (props) => {
  const {
    siteName,
    datiFarmacia,
    logoImage,
    isCheckout,
    primaryColor,
    showDiscountsLinkInFooter,
  } = props;

  return (
    <footer>
      <TopFooter
        isCheckout={isCheckout}
        datiFarmacia={datiFarmacia}
        logoImage={logoImage}
        siteName={siteName}
        primaryColor={primaryColor}
        showDiscountsLinkInFooter={showDiscountsLinkInFooter}
      />
      <BottomFooter primaryColor={primaryColor} datiFarmacia={datiFarmacia} />
    </footer>
  );
};

const mapStateToProps = (state) => ({
  siteName: state.store.singleStore.siteName,
  datiFarmacia: state.store.singleStore,
  logoImage:
    state.store.singleStore.logoFooterImage ||
    state.store.singleStore.logoImage,
  primaryColor: state.store.singleStore.brandColor,
  showDiscountsLinkInFooter: state.store.singleStore.showDiscountsLinkInFooter,
  feedaty: {
    enabled: state.store.singleStore.hasFeedaty,
    widgetId: state.store.singleStore.feedaty.widgetId,
    siteKey: state.store.singleStore.feedaty.siteKey,
  },
});

export default connect(mapStateToProps)(Footer);
